import { useEffect } from "react"
import { useQuery } from "@apollo/client"
import isEmpty from "lodash/isEmpty"
import { showAccountProfileModalVar } from "cache"
import { ACCOUNT_PROFILE_MODAL_TYPE } from "shared/constants"

import { useLoginState } from "components/Login/hooks"
import portal from "portalConfig"
import { Account } from "components/AccountProfileModal/operations"

export const useAccountProfileModal = () => {
  const [isLoggedIn] = useLoginState()
  const { features } = portal.config

  const {
    data: accountData,
    loading: accountLoading,
    refetch
  } = useQuery(Account, {
    skip: !isLoggedIn
  })

  // Check for missing mandatory fields
  const checkMissingFields = (userData) => {
    const { me } = userData
    if (!me) return false

    if (features.userName) {
      if (isEmpty(me.firstName)) return true
      if (isEmpty(me.lastName)) return true
    }
    if (features.userPhoneNumber && isEmpty(me.mobilePhoneNumber)) {
      return true
    }
    if (features.userPostalCode && isEmpty(me.regionCode)) {
      return true
    }

    return false
  }

  // Auto-show modal if there are missing mandatory fields and mandatoryFields feature is enabled
  useEffect(() => {
    if (
      accountData &&
      !accountLoading &&
      isLoggedIn &&
      features.mandatoryFields
    ) {
      const hasMissingFields = checkMissingFields(accountData)
      if (hasMissingFields) {
        showAccountProfileModalVar(ACCOUNT_PROFILE_MODAL_TYPE.mandatoryFields)
      }
    }
  }, [accountData, accountLoading, isLoggedIn, features])

  const closeModal = () => {
    showAccountProfileModalVar(null)
  }

  const handleProfileComplete = () => {
    refetch()
    closeModal()
  }

  return {
    closeModal,
    handleProfileComplete
  }
}
